import { useMemo } from "react";
import { findIndex, forEach, orderBy, reduce } from "lodash";
import { Item } from "@charty/legend/item/model";
import { Gauge } from "../model";

export default function useLegend(sortedGauges: Gauge[]): Item[] {
  return useMemo(
    () =>
      orderBy(
        reduce(
          sortedGauges,
          (result, gauge) => {
            forEach(gauge.series, (serie) => {
              const found = findIndex(result, { id: serie.id });
              if (found !== -1) {
                result[found] = {
                  ...result[found],
                  count: result[found].count + serie.count,
                };
              } else {
                result.push(serie);
              }
            });
            return result;
          },
          []
        ),
        "count"
      ),
    [sortedGauges]
  );
}
